// @flow

import { createContext, useContext } from 'react';
import type { AssertionOptions } from './types';

export type PaymentState =
  | 'LOADING'
  | 'AUTHENTICATING'
  | 'SUBMITTING_AUTH'
  | 'SUCCESS'
  | 'ERROR';

export type PaymentData = {|
  +state: PaymentState,
  +paymentHash: string,
  +assertionOptions: ?AssertionOptions,
  +redirectUrlAfterPayment: ?string,
  +errorMessage: string,
|};

export type PaymentAction =
  | {| +type: 'ASSERTION_OPTIONS_RECEIVED', +assertionOptions: AssertionOptions, +redirectUrlAfterPayment: ?string |}
  | {| +type: 'START_AUTHENTICATING' |}
  | {| +type: 'START_SUBMITTING_AUTH' |}
  | {| +type: 'AUTH_SUBMITTED' |}
  | {| +type: 'SET_ERROR', +errorMessage: string |}
  | {| +type: 'RETRY' |};

type PaymentContextType = {|
  +data: PaymentData,
  +dispatch: (action: PaymentAction) => void,
|};

const PaymentContext = createContext<?PaymentContextType>(null);

export const PaymentProvider = PaymentContext.Provider;

export function usePayment(): PaymentContextType {
  const context = useContext(PaymentContext);
  if (!context) {
    throw new Error('PaymentProvider not found');
  }
  return context;
}
